export const CourseStatus = {
    INITIAL: 0,
    APPROVED: 4,
    HIDDEN: 6,
    PUBLIC: 10,
    OPEN: 14,

    getKey(value) {
        return Object.keys(this).find(key => this[key] === value) || 'UNKNOWN';
    },
    
    getValue(key) {
        return this[key] || this.INITIAL;
    },  

    getColor(value) {
        return value < CourseStatus.PUBLIC ? 'green' : 'red';
    }
};